<template>
  <list-component :entity-name="entityName"
                  :is-nested="true"
                  :parent-api-details="parentApiDetails"
                  :overrides="overrides"
  />
</template>

<script>
import listComponent from '@/components/backoffice/listComponent'

export default {
  components: {
    listComponent
  },
  props: {
    entityName: {
      type: String,
      required: true
    },
    parentApiDetails: {
      type: Object,
      required: true
    },
    overrides: {
      type: Object
    }
  }
}
</script>
